package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateRows
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea

private val defaultContainerModifier = Modifier
    .display(DisplayStyle.Grid)
    .gridTemplateRows {
        size(auto)
        minmax(1.5.cssRem, 1.fr)
        minmax(1.cssRem, auto)
    }
    .gap(0.5.cssRem)

@Composable
fun ControlledTextArea(
    textState: MutableState<String>,
    label: String,
    labelId: String,
    rowCount: Int = 3,
    disabled: Boolean = false,
    maxLength: Int? = null,
    modifier: Modifier = Modifier
) {
    var text: String by remember { textState }
    var touched by remember { mutableStateOf(false) }

    Div(defaultContainerModifier.then(modifier).toAttrs()) {
        Label(labelId) { Text(label) }
        TextArea {
            style {
                padding(0.5.cssRem)
                borderRadius(2.px)
                property("width", "100%")
                property("box-sizing", "border-box")
                property("resize", "vertical")
                property("font-family", "inherit")
                border {
                    style = LineStyle.Solid
                    width = 1.px
                    color = rgb(176, 176, 176)
                }
            }
            rows(rowCount)
            value(text)
            onInput { event ->
                val newValue = event.value
                if (maxLength != null && newValue.length > maxLength) {
                    // ignore
                } else {
                    text = newValue
                }
                touched = true
            }
            if (disabled) { disabled() }
        }
    }
}
